<template>
  <div class='navbar'>
    <el-menu :default-active="obj.menuIdx" mode="horizontal" style="height:50px;min-width:1600px"
      background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" @select="handleSelect">
      <el-image style="width: 30px; height: 30px; padding:0px 30px; padding-top:8px;"
        :src="require('@/assets/logo.png')" :fit="fit" />
      <el-input v-model="obj.searchValue" placeholder="名称/代码 搜索主力合约" @input="handleInput" @keyup.enter="handleEnter"
        style="width:200px;min-width:200px;padding-top:8px;padding-bottom:8px;padding-right:6px;padding-left:6px">
        <template #prefix>
          <el-icon class="el-input__icon">
            <search />
          </el-icon>
        </template>
      </el-input>
      <!-- <el-menu-item index="0">
        <el-icon>
          <house />
        </el-icon>
        <template #title>首页</template>
      </el-menu-item> -->
      <el-menu-item index="1">
        <el-icon>
          <pieChart />
        </el-icon>
        <template #title>行情</template>
      </el-menu-item>
      <el-menu-item index="2" v-if="obj.user.authority === 'C4'">
        <el-icon>
          <pointer />
        </el-icon>
        <template #title>交易</template>
      </el-menu-item>
      <!-- <el-menu-item index="2-1">
        <el-icon>
          <money />
        </el-icon>
        <template #title>共振</template>
      </el-menu-item> -->
      <!-- <el-menu-item index="2-2">
        <el-icon>
          <compass />
        </el-icon>
        <template #title>趋势</template>
      </el-menu-item> -->
      <el-menu-item index="2-3">
        <el-icon>
          <money />
        </el-icon>
        <template #title>信号</template>
      </el-menu-item>
      <el-menu-item index="2-4">
        <el-icon>
          <compass />
        </el-icon>
        <template #title>趋势</template>
      </el-menu-item>
      <el-menu-item index="3">
        <el-icon>
          <operation />
        </el-icon>
        <template #title>基本</template>
      </el-menu-item>
      <!-- <el-sub-menu index="3">
        <template #title>
          <el-icon><operation /></el-icon>
          排行
        </template>
        <el-menu-item index="3-1">item one</el-menu-item>
        <el-menu-item index="3-2">item two</el-menu-item>
        <el-menu-item index="3-3">item three</el-menu-item>
      </el-sub-menu> -->
      <el-menu-item index="4">
        <el-icon>
          <dataAnalysis />
        </el-icon>
        <template #title>收益</template>
      </el-menu-item>
      <el-menu-item index="5">
        <el-icon>
          <crop />
        </el-icon>
        <template #title>技术</template>
      </el-menu-item>
      <el-menu-item index="6">
        <el-icon>
          <cpu />
        </el-icon>
        <template #title>选股</template>
      </el-menu-item>
      <el-menu-item index="7">
        <el-icon>
          <document />
        </el-icon>
        <template #title>相关</template>
      </el-menu-item>
      <!-- <el-menu-item index="8">
        <el-icon>
          <connection />
        </el-icon>
        <template #title>回归</template>
      </el-menu-item>
      <el-menu-item index="9">
        <el-icon>
          <cherry />
        </el-icon>
        <template #title>对冲</template>
      </el-menu-item>
      <el-menu-item index="10">
        <el-icon>
          <dataLine />
        </el-icon>
        <template #title>历史</template>
      </el-menu-item>
      <el-menu-item index="11">
        <el-icon>
          <Switch />
        </el-icon>
        <template #title>回测</template>
      </el-menu-item> -->
      <!-- <el-menu-item index="12">
        <el-icon>
          <infoFilled />
        </el-icon>
        <template #title>资讯</template>
      </el-menu-item> -->
      <!-- <el-menu-item index="14" v-if="obj.user.authority === '机构专业版'">
        <el-icon>
          <editPen />
        </el-icon>
        <template #title>发布</template>
      </el-menu-item> -->
      <el-menu-item index="21">
        <el-icon>
          <avatar />
        </el-icon>
        <template #title>我的</template>
      </el-menu-item>
      <el-menu-item index="22">
        <el-icon>
          <crop />
        </el-icon>
        <template #title>退出</template>
      </el-menu-item>
      <!-- <el-badge :value="12" class="item">
        <el-button>comments</el-button>
      </el-badge> -->
      <!-- <div style="float:right;padding-top:8px;padding-right:8px;padding-left:150px;">
        <el-button type="primary" @click="handleLogout">退出</el-button>
      </div>  
      <div style="padding-top:8px;padding-right:8px">
        <el-avatar :size="30" :src="'http://localhost:8000' + obj.user.avatar" style="cursor: pointer;" @click="handleAvatarClick"/>
        <el-avatar :size="30" :src="'http://124.156.185.124' + obj.user.avatar" style="cursor: pointer;" @click="handleAvatarClick"/>
      </div>   -->
    </el-menu>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }} {{ data['exchange'] }}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
export default {
  setup(props, { emit }) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      user: '',
      menuIdx: '',
      searchList: [],
      filteredList: [],
      searchValue: '',
    })

    // 页面传来的menuIdx处理
    vueEvent.on('navbarMenuIdxEvent', (menuIdx) => {
      obj.menuIdx = menuIdx
    })

    // 页面传来的mainClickEvent处理
    vueEvent.on('mainClickEvent', () => {
      obj.filteredList = []
      obj.searchValue = ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderSelect()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('navbarMenuIdxEvent')
      vueEvent.off('mainClickEvent')
    })

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main")
      http({
        url: '/contract',
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        obj.searchList = res.data.data
      })
      http({
        url: '/user',
        method: 'post'
      }).then((res) => {
        // console.log(res.data)
        obj.user = res.data
        store.commit('setUser', obj.user)
      })
    }

    // 菜单点击事件
    const handleSelect = (menuIdx) => {
      emit('topbarEvent', menuIdx) // 抛出事件到父组件
      if (menuIdx === '0') {
        router.push('/')
      } else if (menuIdx === '1') {
        router.push('/market')
      } else if (menuIdx === "2") {
        router.push('/trade')
      } else if (menuIdx === "2-1") {
        router.push('/resonance')
      } else if (menuIdx === "2-2") {
        router.push('/strategy')
      } else if (menuIdx === "2-3") {
        router.push('/signal')
      } else if (menuIdx === "2-4") {
        router.push('/trend')
      } else if (menuIdx === "3") {
        router.push('/statistic')
      } else if (menuIdx === "4") {
        router.push('/financial_analysis')
      } else if (menuIdx === "5") {
        router.push('/technical')
      } else if (menuIdx === "6") {
        router.push('/picking')
      } else if (menuIdx === "7") {
        router.push('/correlation')
      } else if (menuIdx === "8") {
        router.push('/regression')
      } else if (menuIdx === "9") {
        router.push('/hedge')
      } else if (menuIdx === "10") {
        router.push('/history')
      } else if (menuIdx === "11") {
        router.push('/backtest')
      } else if (menuIdx === "21") {
        router.push('/me')
      } else if (menuIdx === "22") {
        handleLogout()
      }
      // else if (menuIdx === "12") {
      //   router.push('/info')
      // } 
      // else if (menuIdx === "13") {
      //   let routeData = router.resolve({ path: '/doc' });
      //   window.open(routeData.href, '_blank');
      // } 
      // else if (menuIdx === "14") {
      //   router.push('/article_editor')
      // } 
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框回车事件
    const handleEnter = () => {
      if (obj.filteredList.length !== 0) {
        obj.searchValue = obj.filteredList[0]['name']
        obj.filteredList = []
        store.commit('setCurrentContract', obj.searchValue)
        router.push(`/candlestick?name=${obj.searchValue}`)
        obj.searchValue = ''
      }
    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.filteredList = []
      store.commit('setCurrentContract', obj.searchValue)
      router.push(`/candlestick?name=${obj.searchValue}`)
      obj.searchValue = ''
    }

    // 按钮退出登录事件
    const handleLogout = () => {
      http({
        url: '/logout',
        method: 'post',
      }).then((res) => {
        router.push('/login')
      })
      // 清空所有缓存
      // store.commit('setWindowWidth', "")
      // store.commit('setWindowHeight', "")
      store.commit('setUser', "")
      store.commit('setCurrentContract', "")
      store.commit('setMyChart', "")
      // store.commit('setMyChart1', "")
      // store.commit('setMyChart2', "")
      // store.commit('setMyChart3', "")
      store.commit('setChatData', "")
      store.commit('setTrendData', "")
      store.commit('setSignalData', "")
      store.commit('setRankData', "")
      store.commit('setReturnData', "")
      store.commit('setTechnicalData', "")
      store.commit('setPickingData', "")
      store.commit('setCorrelationData', "")
      store.commit('setRegressionData', "")
      store.commit('setHedgeData', "")
      store.commit('setHistoryData', "")
      store.commit('setBacktestData', "")
      // store.commit('setInfoData', "")
      store.commit('setMeData', "")
    }

    // 头像点击事件
    const handleAvatarClick = () => {
      router.push('/me')
    }

    return {
      obj,
      handleSelect,
      handleInput,
      handleEnter,
      handleClick,
      handleLogout,
      handleAvatarClick
    }
  }
}
</script>
<style lang="scss" scoped>
.navbar {
  width: 100%;
  height: 60px;
  left: 60;
  top: 0;
  position: fixed;
  z-index: 15;
}

.el-menu-item {
  height: 50px !important;
}

/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 95px;
  top: 50px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
